import {
  Alert,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Dialog,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { PersonIcon, SearchIcon, SendToIcon } from "evergreen-ui";
import { useEffect, useState } from "react";
import ContactApiService from "../services/ContactApiService";

export function ContactsSelectDialog({
  onClose,
  setSelectedNewContacts,
  open,
  setOpen,
  contactError,
}) {
  const [contacts, setContacts] = useState([]);
  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    ContactApiService.getContactsDetails().then((res) => setContacts(res));
  }, []);

  const handleClose = () => {
    setErrors({});
    setSearchQuery("");
    setContacts([]);
    setOpen(false);
  };
  const handleContactSelection = (contactId) => {
    setContacts((prev) =>
      prev.map((contact) =>
        contact.attrs.id === contactId
          ? { ...contact, isSelected: !contact.isSelected }
          : contact
      )
    );
  };
  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setContacts((prev) =>
      prev.map((contact) => ({ ...contact, isSelected: isChecked }))
    );
  };

  const handleSave = () => {
    const selectedContacts = contacts.filter((contact) => contact.isSelected);
    setSelectedNewContacts(selectedContacts);
    setContacts((prev) =>
      prev.map((contact) => ({ ...contact, isSelected: false }))
    );
  };

  const getTagColor = (tag) => {
    return tag || "#757575";
  };
  const filteredContacts = contacts.filter(
    (contact) =>
      contact.attrs.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      contact.attrs.phoneNumber.includes(searchQuery)
  );
  const selectedContactsCount = contacts.filter(
    (contact) => contact.isSelected
  ).length;
  const isAllSelected =
    contacts.length > 0 && selectedContactsCount === contacts.length;
  const isIndeterminate =
    selectedContactsCount > 0 && selectedContactsCount < contacts.length;
  function renderContacts() {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3, width: 600 }}>
        <Card sx={{ border: "1px solid #e0e0e0", borderRadius: 2 }}>
          <CardContent sx={{ p: 3 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: "#333", mb: 2, fontFamily: `"Poppins", sans-serif` }}
            >
              Select Recipients
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <TextField
                placeholder="Search contacts..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                size="small"
                InputProps={{
                  startAdornment: (
                    <SearchIcon
                      sx={{ color: "#9e9e9e", mr: 0.5, fontSize: 18 }}
                    />
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1.5,
                    backgroundColor: "#fafafa",
                    border: "1px solid #e0e0e0",
                    fontSize: "0.875rem",
                    gap: 2,
                    fontFamily: `"Poppins", sans-serif`,
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                      borderColor: "#d0d0d0",
                    },
                    "&.Mui-focused": {
                      backgroundColor: "#fff",
                      borderColor: "#1976d2",
                    },
                    "& fieldset": {
                      border: "none",
                    },
                  },
                }}
              />
              {filteredContacts.length === 0 ? (
                      <Typography variant="body2" sx={{ display: "flex", justifyContent: "center" }}>
                            No Contacts
                          </Typography>
                    ) : (
                      <><TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{ maxHeight: 400 }}
                  >
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            padding="checkbox"
                            sx={{ backgroundColor: "#f5f5f5" }}
                          >
                            {/* <Checkbox
                              indeterminate={isIndeterminate}
                              checked={isAllSelected}
                              onChange={handleSelectAll}
                              sx={{ color: "#666" }} /> */}
                          </TableCell>
                          <TableCell
                            sx={{ backgroundColor: "#f5f5f5", fontWeight: 600, fontFamily: `"Poppins", sans-serif` }}
                          >
                            Name
                          </TableCell>
                          <TableCell
                            sx={{ backgroundColor: "#f5f5f5", fontWeight: 600, fontFamily: `"Poppins", sans-serif` }}
                          >
                            Phone Number
                          </TableCell>
                          <TableCell
                            sx={{ backgroundColor: "#f5f5f5", fontWeight: 600, fontFamily: `"Poppins", sans-serif` }}
                          >
                            Tags
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredContacts?.map((contact) => (
                          <TableRow
                            key={contact.attrs.id}
                            sx={{
                              "&:hover": {
                                backgroundColor: "#f8f9fa",
                              },
                            }}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={contact.isSelected}
                                onChange={() => handleContactSelection(contact.attrs.id)}
                                sx={{ color: "#666" }} />
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                }}
                              >
                                <Avatar
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    bgcolor: "#1976d2",
                                    fontSize: "0.875rem",
                                  }}
                                >
                                  <PersonIcon />
                                </Avatar>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 500, fontFamily: `"Poppins", sans-serif` }}
                                >
                                  {contact?.attrs.name}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ fontFamily: `"Poppins", sans-serif` }}>
                                {contact.attrs.phoneNumber}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                              >
                                {contact?.attrs.tags.map((tag) => (
                                  <Chip
                                    key={tag.getId()}
                                    label={tag.getName()}
                                    size="small"
                                    sx={{
                                      backgroundColor: `${getTagColor(
                                        tag.getColor()
                                      )}15`,
                                      color: getTagColor(tag.getColor()),
                                      fontWeight: 500,
                                      fontSize: "0.75rem",
                                      fontFamily: `"Poppins", sans-serif`,
                                    }} />
                                ))}
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer><Button
                    onClick={handleSave}
                    variant="contained"
                    startIcon={<SendToIcon />}
                    disabled={selectedContactsCount === 0}
                    sx={{
                      borderRadius: 1.5,
                      textTransform: "none",
                      px: 3,
                      fontFamily: `"Poppins", sans-serif`,
                      background: "linear-gradient(135deg, #4caf50 0%, #45a049 100%)",
                      "&:hover": {
                        background: "linear-gradient(135deg, #45a049 0%, #3d8b40 100%)",
                      },
                      "&.Mui-disabled": {
                        background: "#e0e0e0",
                        color: "#999",
                      },
                    }}
                  >
                      Ok ({selectedContactsCount})
                    </Button></>
                    )}

              
              {selectedContactsCount > 0 && (
                <Alert severity="info" sx={{ fontSize: "0.875rem" }}>
                  <Typography variant="body2" sx={{ fontFamily: `"Poppins", sans-serif` }}>
                    {selectedContactsCount} contact(s) selected
                  </Typography>
                </Alert>
              )}
              {contactError && (
                <Alert severity="error" sx={{ fontSize: "0.875rem" }}>
                  <Typography variant="body2">
                    {contactError}
                  </Typography>
                </Alert>
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>
    );
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxHeight: "90vh",
        },
      }}
    >
      {renderContacts()}
    </Dialog>
  );
}
